<div class="container-fluid {{massiveDetail && dataSource ? 'massive-detail' : ''}} d-flex align-items-center justify-content-center">
    <div>
        <i *ngIf="wait" class="fas fa-circle-notch fa-spin mr-2"></i>
        <div class="table-radius">
            <mat-table *ngIf="massiveDetail && dataSource" [dataSource]="dataSource" matSort>
                <!-- id -->
                <!-- <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('id')">
                        Id
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="Id">
                        <span> #{{ row.id }} </span>
                    </mat-cell>
                </ng-container> -->

                <!-- olo -->
                <!-- <ng-container matColumnDef="olo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('olo')">
                        Olo
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="Olo">
                        <span>{{ row.olo }}</span>
                    </mat-cell>
                </ng-container> -->

                <!-- service -->
                <!-- <ng-container matColumnDef="service">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('service')">Service
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="Service">
                        <span>{{ row.service }}</span>
                    </mat-cell>
                </ng-container> -->

                <!-- b_end -->
                <ng-container matColumnDef="b_end">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('bEnd')">B END
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="BEnd">
                        <span
                            [ngClass]="{bold: row.b_end_research_method !== 'Coordinates WGS84' && row.b_end_research_method !== 'Coordinates ED50'}">{{
                            row.b_end }}</span>
                    </mat-cell>
                </ng-container>

                <!-- b_end_coordinates -->
                <ng-container matColumnDef="b_end_coordinates">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('bEndCoordinates')">
                        Coordinates
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="bEndCoordinates">
                        <span
                            [ngClass]="{bold: row.b_end_research_method === 'Coordinates WGS84' || row.b_end_research_method === 'Coordinates ED50'}">{{
                            row.b_end_coordinates.lat }} - {{ row.b_end_coordinates.lng }}</span>
                    </mat-cell>
                </ng-container>

                <!-- b_end_afference_pop -->
                <ng-container matColumnDef="b_end_afference_pop">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('bEndAfferencePop')">
                        Afference Pop</mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="BEndAfferencePop">
                        <span>{{ row.b_end_afference_pop }}</span>
                    </mat-cell>
                </ng-container>

                <!-- a_end -->
                <ng-container [class.d-none]="!a_end_1" matColumnDef="a_end_1">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('aEnd1')">A END 1
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="AEnd1">
                        <span
                            [ngClass]="{bold: row.a_end_1_research_method !== 'Coordinates WGS84' && row.a_end_1_research_method !== 'Coordinates ED50'}">{{
                            row.a_end_1 }}</span>
                    </mat-cell>
                </ng-container>

                <ng-container [class.d-none]="!a_end_2" matColumnDef="a_end_2">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('aEnd2')">A END 2
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="AEnd2">
                        <span
                            [ngClass]="{bold: row.a_end_2_research_method !== 'Coordinates WGS84' && row.a_end_2_research_method !== 'Coordinates ED50'}">{{
                            row.a_end_2 }}</span>
                    </mat-cell>
                </ng-container>

                <!-- cluster -->
                <!-- <ng-container matColumnDef="cluster">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('cluster')">
                        Cluster</mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="Cluster">
                        <span>{{ row.cluster }}</span>
                    </mat-cell>
                </ng-container> -->

                <!-- total_cost_commercial -->
                <!-- <ng-container matColumnDef="total_cost_commercial">
                    <mat-header-cell *matHeaderCellDef mat-sort-header (click)="onClickSort('totalCostCommercial')">
                        Total Cost</mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="TotalCostCommercial">
                        <span>{{ row.total_cost_commercial }}</span>
                    </mat-cell>
                </ng-container> -->

                <!-- total_elapsed -->
                <!-- <ng-container matColumnDef="total_elapsed">
                    <mat-header-cell *matHeaderCellDef>Total Elapsed</mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="TotalElapsed">
                        <span>{{ row.total_elapsed }}</span>
                    </mat-cell>
                </ng-container> -->

                <!-- total_distance -->
                <!-- <ng-container matColumnDef="total_distance">
                    <mat-header-cell *matHeaderCellDef>Total Distance</mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="TotalDistance">
                        <span>{{ row.total_distance }}</span>
                    </mat-cell>
                </ng-container> -->

                <!-- feasibility_check -->
                <!-- <ng-container matColumnDef="feasibility_check">
                    <mat-header-cell *matHeaderCellDef>Feasibility Check</mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="FeasibilityCheck">
                        <span>{{ row.feasibility_check }}</span>
                    </mat-cell>
                </ng-container> -->

                <!-- actions -->
                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                    <mat-cell *matCellDef="let row" data-label="FeasibilityCheck">
                        <span class="action" (click)="removeId(row.id)">{{ ignoredIds.indexOf(row.id) > -1 ?
                            'Restore' : 'Remove' }}</span>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; let even = even; columns: displayedColumns"
                    [ngClass]="{'removed': ignoredIds.indexOf(row.id) > -1, gray: even }"></mat-row>
            </mat-table>
            <mat-paginator *ngIf="massiveDetail" [length]="massiveDetail.count_total" [pageSize]="10"
                (page)="setPage($event)">
            </mat-paginator>
        </div>
        <button *ngIf="massiveDetail" class="btn send mt-3" (click)="sendToSalesforce()">Send</button>
    </div>
</div>